/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import React, { forwardRef, useState } from 'react'
import { TextInput as RNTextInput } from 'react-native'

import { TextInputProps } from 'ui/components/inputs/types'
import { PasswordRules } from 'ui/designSystem/PasswordInput/components/PasswordRules'
import { RightButton } from 'ui/designSystem/PasswordInput/components/RightButton'
import { TextInput } from 'ui/designSystem/TextInput/TextInput'

type Props = Omit<TextInputProps, 'secureTextEntry' | 'rightButton'> & {
  value: string
  onChangeText: (value: string) => void
  autocomplete: 'new-password' | 'current-password'
  displayValidation?: boolean
}

export const PasswordInput = forwardRef<RNTextInput, Props>(
  (
    {
      label,
      value,
      onChangeText,
      description,
      errorMessage,
      disabled,
      requiredIndicator,
      autocomplete,
      displayValidation,
      accessibilityHint,
      ...inputProps
    },
    ref
  ) => {
    const [shouldHidePassword, setShouldHidePassword] = useState(true)

    return (
      <React.Fragment>
        <TextInput
          ref={ref}
          label={label}
          description={description}
          value={value}
          onChangeText={onChangeText}
          autoCapitalize="none"
          secureTextEntry={shouldHidePassword}
          errorMessage={errorMessage}
          disabled={disabled}
          autoComplete={autocomplete}
          requiredIndicator={requiredIndicator}
          rightButton={RightButton({
            shouldHidePassword,
            setShouldHidePassword,
            disabled,
          })}
          accessibilityHint={accessibilityHint}
          testID={label}
          {...inputProps}
        />
        <PasswordRules visible={displayValidation} password={value} />
      </React.Fragment>
    )
  }
)

PasswordInput.displayName = 'PasswordInput'
